/* tslint:disable:typedef-whitespace align no-trailing-whitespace */

import { Action, ActionType    } from '@/models/action';
import { Logger                } from '@/util/logger';

/**
 *
 * @class HelpFaqAction
 *
 * @brief view the FAQ
 *
 * - - - - - - - - - - - - - - - - - - -
 * @author    Michael Garvin (mike.garvin@ironroad.ca)
 * @date      March 2020
 *
 */
export class HelpFaqAction extends Action {

  constructor(options: any = null) {

    super({
      key:   'help.faq',
      type:  ActionType.Help_FAQ,
      label: 'FAQ',
      icon:  '<i class="fas fa-list"></i>',
      tip:   'View the Frequently Asked Questions (FAQ)'
    });

  }

  /* is this action enabled? */
  public enabled(): boolean {

    return true;
  }

  /** implement the action */
  public execute(): boolean {

    if (!this.enabled()) {
      return false;
    }

    Logger.debug('[HelpFaqAction] executing...');

    return true;
  }
}
